import "./App.scss";
import { Route, Routes } from "react-router-dom";
import ProjectDetails from "./components/ProjectDetails";
import { StateContext } from "./Context/Context";
import { useState, useEffect, useRef } from "react";
import { loading, WindowHover } from "./Animation";
import Homepage from "./components/newpages/Homepage";
import FixedHeader from "./components/newpages/sections/components/FixedHeader";
import FixedLeftSideBar from "./components/newpages/sections/components/FixedLeftSideBar";
import FixedRightSideBar from "./components/newpages/sections/components/FixedRightSideBar";
import { useLocation } from "react-router-dom";
import ScrollToTop from "./components/newpages/sections/components/ScrollToTop";

function App() {
  useEffect(() => {
    WindowHover(shape2, shape1);
  }, []);

  const [state, setState] = useState({ num: 0, field: "home" });
  let shape1 = useRef(null);
  let shape2 = useRef(null);
  let node1 = useRef(null);
  let node2 = useRef(null);
  let node3 = useRef(null);
  let node4 = useRef(null);
  let node5 = useRef(null);
  let node6 = useRef(null);

  useEffect(() => {
    document.body.classList.add("dark");
    loading(node1, node2, node3, node4, node5, node6);
  }, []);

  const { pathname } = useLocation();

  return (
    <StateContext.Provider value={{ state, setState }}>
      <div>
        <div className="shape1 shape" ref={(e) => (shape1 = e)}></div>
        <div className="shape2 shape" ref={(e) => (shape2 = e)}></div>
      </div>
      <div className="fadeCase" ref={(e) => (node1 = e)}>
        <div className="fadeIn1" ref={(e) => (node2 = e)}></div>
        <div className="fadeIn2" ref={(e) => (node4 = e)}>
          <div className="cssload-thecube">
            <div className="cssload-cube cssload-c1"></div>
            <div className="cssload-cube cssload-c2"></div>
            <div className="cssload-cube cssload-c4"></div>
            <div className="cssload-cube cssload-c3"></div>
          </div>
          <h1>
            <span ref={(e) => (node5 = e)} className="span1">
              Ose
            </span>
            <span ref={(e) => (node6 = e)} className="span2">
              Best
            </span>
          </h1>
        </div>
        <div className="fadeIn3" ref={(e) => (node3 = e)}></div>
      </div>
      <div className="bg-white dark:!bg-darkBackground">
        <FixedHeader />
        {!pathname.includes("details") && (
          <>
            <FixedLeftSideBar />
            <FixedRightSideBar />
          </>
        )}
        <div
          className={`my-0 mx-auto py-[15px] pl-[13%] pr-[5%] sm:pl-[12%] ${
            pathname.includes("details") ? "!px-[5%]" : ""
          } text-black bg-white dark:!text-white dark:!bg-darkBackground`}
        >
          {/* <Header /> */}
          <ScrollToTop>
            <Routes>
              <Route path="/" element={<Homepage />} />
              {/* <Route path="/about" element={<About />} />
            <Route path="/projects" element={<Projects />} /> */}
              <Route path="/projects/details" element={<ProjectDetails />} />
              {/* <Route path="/contact" element={<Contact />} /> */}
            </Routes>
          </ScrollToTop>
        </div>
      </div>
    </StateContext.Provider>
  );
}

export default App;
